module.exports = __webpack_public_path__ + "img/40GP_HQ.e80baff0.svg";